import { mapGetters, mapActions } from "vuex";

export default {
	name: "free-access",
	data() {
		return {
			show			: false,
			status			: true,
			showContinue	: false,
			activeTo		: ''
		};
	},
	watch: {},
	computed: {
		...mapGetters({
			currentItem		: "courses/currentItem",
			user			: "user/user",
			userFreeAccess	: "user/userFreeAccess",
		}),
	},
	async created() {
		//console.log('free-access created');
		
		this.unwatchCurrentItem = this.$store.watch(
			(state, getters) => getters['courses/currentItem'],
			(val, oldVal) => {
				//console.log('currentItem changed:', val);
				
				this.onCurrentItemChanged(val, oldVal);
			},
			{
				deep		: true, 
				immediate	: true
			}
		);
		
		//this.check();
	},
	beforeDestroy() {
		this.unwatchCurrentItem && this.unwatchCurrentItem();
	},
	methods: {
		...mapActions({
			fetchUserFreeAccess: "user/GET_USER_FREE_ACCESS",
		}),
		onCurrentItemChanged(val) {
			//console.log('val:', val);
			//console.log('oldVal:', oldVal);
			
			this.check(val);
		},
		async check(course){
			//console.log('free-access check');
			
			if(!course && this.currentItem){
				course = this.currentItem;
			}
			
			if(this.$route.name == 'courses'){
				course = null;
			}
			
			await this.fetchUserFreeAccess();
			
			//console.log('userFreeAccess:');
			//console.log(this.userFreeAccess);
			//console.log('');
			
			this.activeTo		= '';
			this.show			= false;
			this.showContinue	= false;
			
			var isCurrent = false;
			
			if(this.userFreeAccess && this.userFreeAccess.length){
				var paid = false;
				var free = false;
				
				//var hasAccess;
				
				const now = new Date();
				
				for(let i = 0; i < this.userFreeAccess.length; i++){
					if(this.userFreeAccess[i].isConnected){
						if(this.userFreeAccess[i].type == "free"){
							free = true;
							
							//console.log('course:', course);
							//console.log('coursesIds:', this.userFreeAccess[i].coursesIds);
							
							const activeToDate = new Date(this.userFreeAccess[i].activeTo);
							const diffDays = Math.floor((activeToDate - now) / (1000 * 60 * 60 * 24));
							
							//console.log('diffDays:', diffDays);
							
							if (diffDays <= 60) {
								if(course){
									if(
										this.userFreeAccess[i].coursesIds && 
										this.userFreeAccess[i].coursesIds.length && 
										this.userFreeAccess[i].coursesIds.includes(course.id)
									){
										isCurrent = true;
										
										//console.log('hasAccess');
										
										this.activeTo = this.userFreeAccess[i].activeTo;
									}else{
										//console.log('no Access');
									}
								}else{
									//console.log('else');
									
									this.activeTo = this.userFreeAccess[i].activeTo;
								}
							}
						}
						
						if(
							this.userFreeAccess[i].type == "paid" || 
							this.userFreeAccess[i].type == "main"
						){
							paid = true;
						}
					}
				}
				
				//console.log('free:', free);
				//console.log('paid:', paid);
				
				//console.log('activeTo:', this.activeTo);
				//console.log('name:', this.$route.name);
				
				if(
					free && 
					this.activeTo && 
					(
						this.$route.name == 'courses' || 
						(
							this.$route.name != 'courses' && 
							course
						)
					)
				){
					if(this.$route.name == 'courses' && paid){
						//return;
					}
					
					//this.show = true;
					
					const date = new Date();
					
					//console.log('date:', date);
					//console.log('month:', date.getMonth());
					//console.log('day:'	, date.getDate());
					
					if(
						(
							date.getFullYear() == 2025 && 
							date.getMonth() == 11
						) && 
						(
							(
								date.getDate() > 7 && 
								date.getDate() < 13
							)
						)
					){
						//console.log('showContinue');
						
						this.show			= true;
						
						if(
							course && 
							isCurrent
						){
							this.showContinue	= false;
						}else{
							this.showContinue	= true;
						}
					}else{
						if(this.$route.name == 'courses' && paid){
							this.show = false;
						}else{
							this.show = true;
						}
					}
				}else{
					const date = new Date();
					
					//console.log('date2:', date);
					//console.log('month:', date.getMonth());
					//console.log('day:'	, date.getDate());
					
					if(
						!this.activeTo && 
						(
							date.getFullYear() == 2025 && 
							date.getMonth() == 11
						) && 
						(
							(
								date.getDate() > 7 && 
								date.getDate() < 13
							)
						)
					){
						this.show = true;
						this.showContinue	= true;
					}
				}
			}
		}
	}
};
